module.exports = __webpack_public_path__ + "static/media/search.html.31d6cfe0.txt";